import { RESET_STATE } from 'store/global/actions';

import { LOAN_CONSENTS_ACTION_TYPE } from '../actions';

const initialState = {};

const loanConsents = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_CONSENTS_ACTION_TYPE.GET_APPLICATION_CONSENTS:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanConsents;
